import type { AuthorKind } from '@sigora/domain';

/**
 * What the Materials step's history says of each version: one module, so the product copy is one
 * file to change.
 */

/** The line a version reads as: who made it, and whether it is the version confirmed now. */
export const materialsHistoryLine = ({
  version,
  authoredBy,
  confirmed,
}: {
  version: number;
  authoredBy: AuthorKind;
  confirmed: boolean;
}): string =>
  `Version ${String(version)}: ${authoredBy === 'user' ? 'saved by you' : 'read from your files by Sigora'}${confirmed ? ' · confirmed' : ''}`;

/** The toggle that shows and hides the history. */
export const MATERIALS_HISTORY_TOGGLE = { closed: 'History', open: 'Hide history' } as const;
